import { render } from "./SecondaryButton.vue?vue&type=template&id=e6460c30&scoped=true"
import script from "./SecondaryButton.vue?vue&type=script&lang=js"
export * from "./SecondaryButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/whisk/whisk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6460c30"]])

export default __exports__